/**
 * Copyright IBM Corp. 2020, 2025
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';
import { useIsomorphicEffect } from './useIsomorphicEffect.js';

var usePrefersReducedMotion = function usePrefersReducedMotion() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    prefersReducedMotion = _useState2[0],
    setPrefersReducedMotion = _useState2[1];
  useIsomorphicEffect(function () {
    var mediaQueryList = window.matchMedia('(prefers-reduced-motion: no-preference)');
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: no-preference)'),
      matches = _window$matchMedia.matches;
    setPrefersReducedMotion(!matches);
    var listener = function listener(event) {
      setPrefersReducedMotion(!event.matches);
    };
    mediaQueryList.addEventListener('change', listener);
    return function () {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, []);
  return prefersReducedMotion;
};

export { usePrefersReducedMotion };
